(function () {
  var STORAGE_KEY = 'zb-wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
  }

  function isWishlisted(handle) {
    return getWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function updateButtonState(button) {
    var handle = button.getAttribute('data-handle');
    var active = isWishlisted(handle);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.classList.toggle('is-active', active);
  }

  function toggleWishlist(button) {
    var handle = button.getAttribute('data-handle');
    var list = getWishlist();
    var exists = list.some(function (item) {
      return item.handle === handle;
    });

    if (exists) {
      list = list.filter(function (item) {
        return item.handle !== handle;
      });
    } else {
      list.push({
        handle: handle,
        title: button.getAttribute('data-title'),
        url: button.getAttribute('data-url'),
        image: button.getAttribute('data-image')
      });
    }

    saveWishlist(list);
    updateButtonState(button);

    button.classList.remove('zb-pulse');
    // eslint-disable-next-line no-unused-expressions
    button.offsetWidth; /* restart animation */
    button.classList.add('zb-pulse');

    document.dispatchEvent(
      new CustomEvent('zb:wishlist:updated', { detail: { list: list, handle: handle } })
    );
  }

  function initWishlistButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-zb-wishlist-toggle]');

    buttons.forEach(function (button) {
      if (button.getAttribute('data-zb-wishlist-bound') === 'true') {
        return;
      }

      button.setAttribute('data-zb-wishlist-bound', 'true');
      updateButtonState(button);

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleWishlist(button);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWishlistButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initWishlistButtons(event.target);
  });
})();
